import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import '@arabquiz/i18n'
import type common from '@arabquiz/i18n/locales/ar/common.json'

i18n
.use(LanguageDetector)
  .use(resourcesToBackend((language: string, namespace: string) => import(`../../../../libs/ts/i18n/src/locales/${language}/${namespace}.json`)))
  .use(initReactI18next)
  .init({
    fallbackLng: 'ar',
    supportedLngs: ['ar'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'quiz', 'game', 'validation', 'admin'],
    interpolation: { escapeValue: false },
    detection: { order: ['htmlTag', 'navigator'] }
  })

export default i18n
